import { render } from "./icon-minus.svg?vue&type=template&id=1a64ac31?inline"
const script = {}
script.render = render

export default script